// VerifyEmailPage — 이메일 인증 처리(메일 토큰 링크).
import { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../api/client';
import useIsMobile from '../hooks/useIsMobile';
import { COLORS } from '../utils/uiStyles';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const called = useRef(false);
  const mobile = useIsMobile();
  const S = styles(mobile);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('유효하지 않은 링크입니다.'); return; }
    authAPI.verifyEmail(token)
      .then((res) => { setStatus('success'); setMessage(res.data.message); })
      .catch((err) => { setStatus('error'); setMessage(err.response?.data?.detail || '인증에 실패했습니다.'); });
  }, [searchParams]);

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <h2 style={S.title}>이메일 인증</h2>
        {status === 'verifying' && <p style={S.muted} role="status">인증 처리 중...</p>}
        {status === 'success' && <>
          <p style={S.ok} role="status">{message}</p>
          <button style={S.btn}
            onClick={() => navigate('/login')}>로그인하기</button>
        </>}
        {status === 'error' && <>
          <p style={S.err} role="alert">{message}</p>
          <button style={S.secondaryBtn} onClick={() => navigate('/login')}>로그인으로 돌아가기</button>
        </>}
      </div>
    </div>
  );
}

const styles = (mobile) => ({
  wrap: { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'var(--gw-app-h, 100dvh)', background:'#f5f5f5', boxSizing:'border-box', padding: mobile ? '16px' : 0 },
  card: { background:'white', padding: mobile ? '28px 20px' : '40px', borderRadius:'12px', textAlign:'center', width: mobile ? '100%' : '360px', maxWidth: mobile ? '420px' : undefined, boxShadow: mobile ? 'none' : '0 2px 12px rgba(0,0,0,.1)', boxSizing:'border-box' },
  title: { margin:'0 0 16px', fontSize:'20px', fontWeight:700, color:'#1f2937' },
  muted: { color:'#6b7280', fontSize:'14px', margin:0 },
  ok: { color:'#166534', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'10px', padding:'12px', margin:'0 0 16px', fontSize:'14px', lineHeight:1.6 },
  err: { color:'#b91c1c', background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'10px', padding:'12px', margin:'0 0 16px', fontSize:'14px', lineHeight:1.6 },
  btn: { width:'100%', minHeight: mobile ? '48px' : '42px', padding:'10px 24px', background:COLORS.primary, color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontWeight:700 },
  secondaryBtn: { width:'100%', minHeight: mobile ? '48px' : '42px', padding:'10px 24px', background:'#f3f4f6', color:'#374151', border:'none', borderRadius:'6px', cursor:'pointer', fontWeight:700 },
});
